import { Directive, Input, } from '@angular/core';
import * as i0 from "@angular/core";
export class LinkDirective {
    viewContainer;
    templateRef;
    renderer;
    elementRef;
    editable = true;
    attrs = {};
    field;
    inlineRef = null;
    constructor(viewContainer, templateRef, renderer, elementRef) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    ngOnChanges(changes) {
        if (changes.field || changes.editable || changes.attrs) {
            this.viewContainer.clear();
            if (this.inlineRef) {
                this.inlineRef.remove();
                this.inlineRef = null;
            }
            this.updateView();
        }
    }
    renderTemplate(props, linkText) {
        const viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        viewRef.rootNodes.forEach((node) => {
            Object.entries(props).forEach(([key, propValue]) => {
                this.updateAttribute(node, key, propValue);
            });
            if (node.childNodes && node.childNodes.length === 0 && linkText) {
                node.textContent = linkText;
            }
        });
    }
    updateAttribute(node, key, propValue) {
        if (typeof propValue !== 'string' || !propValue || propValue === '') {
            return;
        }
        if (key === 'href') {
            const isInvalidLink = !propValue || /^https?:\/\/$/.test(propValue);
            if (isInvalidLink) {
                if (!node.href) {
                    return;
                }
                propValue = node.href;
            }
            this.renderer.setAttribute(node, key, propValue);
        }
        else if (key === 'class' && node.className !== '') {
            this.renderer.setAttribute(node, key, `${node.className} ${propValue}`);
        }
        else {
            this.renderer.setAttribute(node, key, propValue);
        }
    }
    updateView() {
        const field = this.field;
        if (this.editable && field && field.editableFirstPart && field.editableLastPart) {
            this.renderInlineWrapper(field.editableFirstPart, field.editableLastPart);
        }
        else if (field && (field.href || field.value)) {
            const props = field.href ? field : field.value;
            const linkText = field.text || field.value?.text || field.href || field.value?.href;
            const anchor = props?.anchor ? `#${props.anchor}` : '';
            const href = `${props?.href}${anchor}`;
            const mergedAttrs = { ...props, ...this.attrs, href };
            delete mergedAttrs.anchor;
            this.renderTemplate(mergedAttrs, linkText);
        }
    }
    renderInlineWrapper(editableFirstPart, editableLastPart) {
        const span = this.renderer.createElement('span');
        span.className = 'sc-link-wrapper';
        span.innerHTML = editableFirstPart + editableLastPart;
        // assign attributes from template to inline wrapper
        const attrs = {
            ...this.getElementAttrs(),
            ...this.attrs,
        };
        Object.entries(attrs).forEach(([key, attrValue]) => this.updateAttribute(span, key, attrValue));
        this.viewContainer.createEmbeddedView(this.templateRef);
        const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
        this.renderer.insertBefore(parentNode, span, this.elementRef.nativeElement);
        this.inlineRef = span;
    }
    getElementAttrs() {
        const view = this.templateRef.createEmbeddedView(null);
        const element = view.rootNodes[0];
        if (!element) {
            view.destroy();
            return {};
        }
        const attrs = {};
        for (let i = 0; i < element.attributes.length; i++) {
            const attr = element.attributes.item(i);
            if (attr) {
                attrs[attr.name] = attr.value;
            }
        }
        view.destroy();
        return attrs;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LinkDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: LinkDirective, selector: "[scLink]", inputs: { editable: ["scLinkEditable", "editable"], attrs: ["scLinkAttrs", "attrs"], field: ["scLink", "field"] }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LinkDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[scLink]' }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { editable: [{
                type: Input,
                args: ['scLinkEditable']
            }], attrs: [{
                type: Input,
                args: ['scLinkAttrs']
            }], field: [{
                type: Input,
                args: ['scLink']
            }] } });
